<template>

    <TemplateBasic 
      v-bind:breadcrumb="breadcrumb"
      v-bind:permission="permission">

      <div class="row form-group">

        <div class="col">
          <div class="row">
            <!-- <div class="btn-block-xs-only">
              <AppAddButton v-bind:permission="permission">
                <button @click.prevent="onAddButtonClick" class="btn btn-rounded btn-info btn-block-xs-only" style="background: rgb(81, 137, 127); color: #fff;">
                  Add Parker
                </button>
              </AppAddButton>
            </div> -->

            <div class="btn-block-xs-only">
              <div class="col">
                <button @click.prevent="onBackApplicationButtonClick" v-show="showBackToApplication" class="btn btn-rounded btn-warning btn-block-xs-only">
                  Back to Parking License Application
                </button>
              </div>
            </div>
          </div>
        </div>

        <AppSearch 
          ref="pageSearch"
          class="col-md-4"
          v-on:search-data-change="loadData" />
        
      </div>

      <AppFilter 
        ref="pageFilter" 
        filterKey="customerID"
        v-on:filter-data-change="onFilterDataChange" />
      
      <AppTable 
        ref="pageTable" 
        v-bind:tableParameter="PARAM" 
        v-bind:permission="permission"
        v-on:table-data-click="onTableDataClick" 
        v-on:table-page-change="onTablePageChange" />

      <TemplateFeedback ref="pageFeedback" />
      
      <AppModalForm 
        ref="pageModal" 
        v-bind:formParameter="PARAM" 
        v-bind:permission="permission"
        v-on:modal-data-add="onModalAddDataClick"
        v-on:modal-data-edit="onModalEditDataClick"
        v-on:modal-data-delete="onModalDeleteDataClick" />

    </TemplateBasic>

</template>

<script>
import TemplateBasic from "@/components/Template/TemplateBasic";
import TemplateButton from "@/components/Template/TemplateButton";
import TemplateFeedback from "@/components/Template/TemplateFeedback";
import AppSearch from "@/components/App/AppSearch";
import AppPaging from "@/components/App/AppPaging";
import AppFilter from "@/components/App/AppFilter";
import AppTable from "@/components/App/AppTable";
import AppAddButton from "@/components/App/AppAddButton";
import AppModalForm from "@/components/App/AppModalForm";
import validation from "@/components/Utility/Validation"
import helper from "@/components/Utility/Helper"

var querystring = require('querystring');

const PARAM = [
  {
    key: '_index',
    index: true,
  },
  {
    key: 'customerID',
    text: 'Personal Full Name',
    table_hide: true,
    form_select: {
      data: [],
      formatSelectOptionText: (dataItem) => dataItem.nationalID ? `${dataItem.name} (${dataItem.nationalID})` : dataItem.name,
    },
    form_chosen: true,
    form_edit_input_attr: {
      disabled: true,
    }
  },
  {
    key: '_customerName',
    text: 'Personal Full Name',
    form_hide: true,
    form_input_validation: [],
  },
  {
    key: '_customerNationalID',
    text: 'NIRC / Passport No.',
    form_hide: true,
    form_input_validation: [],
  },
  {
    key: 'name',
    text: 'Parker Full Name',
    table_popup: true,
    // form_edit_input_attr: {
    //   disabled: true,
    // },
  },
  {
    key: 'mobile',
    text: 'Mobile No.',
    form_phone: true,
    // form_edit_input_attr: {
    //   disabled: true,
    // },
    form_input_attr: {
      placeholder: '60XXXXXXXXX',
    },
  },
  {
    key: 'car1',
    text: 'Car Plate',
  },
  {
    key: 'email',
    text: 'Email',
    form_email: true,
    // form_edit_input_attr: {
    //   disabled: true,
    // },
  },
  // {
  //   key: '_createDate',
  //   text: 'Date Created',
  //   form_add_hide: true,
  //   form_input_attr: {
  //     disabled: true,
  //   },
  //   form_input_validation: [],
  // },
  {
    key: 'parkingLicense',
    text: 'Parking License',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex]['_license'];
      if(!dataItem) {
        return '';
      }
      if(dataItem['_licenseStatus'] === 'Pending' || dataItem['_licenseStatus'] === 'Pending Initial Payment' || dataItem['_licenseStatus'] === 'Terminated') {
        return helper.plFormPLNum(dataItem.licenseOperatorNum, dataItem.carparkID);
      }
      return `<a target="_blank" href="${helper.WEB_URL}/parkinglicenseView?licenseID=${dataItem.id}">${helper.plFormPLNum(dataItem.licenseOperatorNum, dataItem.carparkID)}</a>`;
    },
    form_hide: true, 
    form_input_validation: [],
  },
];

const PARAM_MAP = helper.transformParamToMap(PARAM);

export default {
  name: "PagePersonalParker",
  components: {
    TemplateBasic,
    TemplateButton,
    AppSearch,
    AppPaging,
    AppFilter,
    AppTable,
    AppAddButton,
    AppModalForm,
    TemplateFeedback,
  },
  data () {
    return {
      permission : null,
      breadcrumb : [
        { name: 'Home', url: helper.WEB_URL },
        { name: 'Customer List' },
        { name: 'Personal', url: '/personal' },
        { name: 'Parker' },
      ],

      PARAM,
      PARAM_MAP,

      showBackToApplication: false,
    }
  },
  mounted() {
    if(!helper.hasViewPermission(this.permission = helper.getPermission(this))) {
      return;
    }
    
    this.$refs['pageFilter'].formatFilterOptionText = (dataItem) => dataItem.nationalID ? `${dataItem.name} (${dataItem.nationalID})` : dataItem.name;
    
    this.$nextTick(() => {
      helper.setSidebar('/personal');
    });

    this.showBackToApplication = this.$route.query.redirect;

    this.loadCustomer();
  },
  methods: {
    loadCustomer() {
      this.$refs['pageFilter'].setFilterLoading('Loading customer data...');

      this.$http
        .get(
          helper.SERVER_URL + '/api2/customer/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          response.data = response.data.filter(k => !k.isCompany);
          // this.$refs['pageFilter'].setFilterDataWithValueIfFirstLoad([].concat({name: 'All Customer'}, response.data), this.$route.query.customerID);
          this.$refs['pageFilter'].setFilterDataWithValueIfFirstLoad(response.data, this.$route.query.customerID);
          helper.inputSelectSetOption(this.PARAM_MAP['customerID'], response.data);
          this.loadLicense();
        })
        .catch(error => {
          this.$refs['pageFilter'].setFilterError(helper.parseAxiosErrorMessage(this, error, 'loading', 'customer data'));
        });
    },
    loadLicense() {
      this.$refs['pageTable'].setTableData(null);

      let url = helper.SERVER_URL;
      url += '/api2/license/';
      // if(this.$refs['pageFilter'].filterValue) {
      //   url += '?customerID=' + this.$refs['pageFilter'].filterValue;
      // }

      let feedbackItem = 'parking license data'
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pageLicense = response.data;
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.loadLease();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'license data'));
        })
    },
    loadLease() {
      this.$refs['pageTable'].setTableData(null);

      let url = helper.SERVER_URL;
      url += '/api2/lease/';
      // if(this.$refs['pageFilter'].filterValue) {
      //   url += '?customerID=' + this.$refs['pageFilter'].filterValue;
      // }

      let feedbackItem = 'parking license subscription data'
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pageLease = response.data;
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.loadData();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'license data'));
        })
    },
    loadData() {
      this.$refs['pageTable'].setTableLoading('Loading parker data...');

      let url = this.getUrl(this.$refs['pageFilter'].filterValue);
      url = helper.appendSearchQuery(url, this.$refs['pageSearch'].searchValue);
      url = helper.appendPagingQuery(url, this.$refs['pageTable'].getCurrentPage());

      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response, true);
          // let temp = [];
          response.data.forEach(parker => {
            parker['_customer'] = helper.inputSelectFindOption(this.PARAM_MAP['customerID'], parker['customerID']);
            if(parker['_customer']) {
              parker['_customerName'] = parker['_customer'] ? parker['_customer'].name : '';
              parker['_customerNationalID'] = parker['_customer'] ? parker['_customer'].nationalID : '';
              parker['_createDate'] = helper.formatDateTime(parker['createDate']);
              // temp.push(parker);
              parker['_lease'] = this.pageLease.find(k => k.parkerID === parker.id) || {};
              parker['_license'] = this.pageLicense.find(k => k.id === parker['_lease']['licenseID']);
            }
          });
          // this.$refs['pageTable'].setTableData(temp);
          this.$refs['pageTable'].setTableData(response.data, this.$refs['pageTable'].getCurrentPage());
        })
        .catch(error => {
          this.$refs['pageTable'].setTableError(helper.parseAxiosErrorMessage(this, error, 'loading', 'parker data'));
        })
    },

    getUrl(customerID) {
      let url = helper.API_URL + '/api2';
      if(customerID) {
        url += '/customer/' + customerID;
      }
      url += '/parker/';

      return url;
    },

    onTablePageChange() {
      this.loadData();
    },
    onSearchChange(dataIndex) {
      this.$refs['pageTable'].setCurrentPage(1);
      this.loadData();
    },
    onFilterDataChange(dataIndex) {
      this.$refs['pageTable'].setCurrentPage(1);
      this.loadLicense();
    },

    onAddButtonClick() {
      this.$refs['pageFeedback'].setFeedbackMessage();
      
      let defaultData = this.$refs['pageModal'].$refs['modalForm'].getFormDefaultData();
      defaultData['customerID'] = this.$refs['pageFilter'].filterValue;

      this.$refs['pageModal'].setModalOpen(true, 'Add New Parker', defaultData);
    },
    onTableDataClick(tableData, tableDataIndex) {
      this.$refs['pageFeedback'].setFeedbackMessage();
      this.$refs['pageModal'].setModalOpen(false, 'Edit ' + tableData[tableDataIndex]['name'], tableData[tableDataIndex]);
    },
    onBackApplicationButtonClick() {
      helper.redirect({ path: this.$route.query.redirect, query: { customerID: this.$refs['pageFilter'].filterValue }});
    },

    async onModalAddDataClick(selectedData) {
      let feedbackItem = selectedData.name;
      
      this.$refs['pageModal'].setModalLoading('Adding parker ' + feedbackItem);
      this.$http
        .post(
          this.getUrl(selectedData.customerID),
          querystring.stringify(selectedData),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.upsertDataComplete('Successfully added parker ' + feedbackItem);
        })
        .catch(error => {
          this.$refs['pageModal'].setModalError(helper.parseAxiosErrorMessage(this, error, 'adding parker', feedbackItem));
        })
    },
    onModalEditDataClick(selectedData) {
      this.$refs['pageModal'].setModalLoading('Updating ' + selectedData.name);

      this.$http
        .put(
          this.getUrl(selectedData.customerID) + selectedData.id,
          querystring.stringify(selectedData),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.upsertDataComplete('Successfully update ' + selectedData.name);
        })
        .catch(error => {
          this.$refs['pageModal'].setModalError(helper.parseAxiosErrorMessage(this, error, 'updating', 'data'));
        })
    },
    onModalDeleteDataClick(selectedData) {
      this.$refs['pageModal'].setModalLoading('Deleting ' + selectedData.name);

      this.$http
        .delete(
          this.getUrl(selectedData.customerID) + selectedData.id,
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.upsertDataComplete('Successfully delete ' + selectedData.name);
        })
        .catch(error => {
          this.$refs['pageModal'].setModalError(helper.parseAxiosErrorMessage(this, error, 'deleting', 'data'));
        })
    },
    upsertDataComplete(message) {
      this.$refs['pageModal'].setModalClose();
      this.$refs['pageFeedback'].setFeedbackMessage(message);
      this.loadData();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Page/ParkingLicense/PagePersonalParker.vue